import message from 'ant-design-vue/es/message';
import 'ant-design-vue/es/message/style';

message.config({
  top: '10px',
  duration: 3,
  maxCount: 3
});

const ToastMaker = (type = 'info') => {
  if (!message[type]) {
    throw new Error(`Message of ${type} is not defined`);
  }

  let defaultDuration = 3;
  if (type === 'loading') {
    defaultDuration = 0;
  }

  return (content = '', duration = defaultDuration, onClose) => {
    // Call the message API to show the toast
    message[type](content, duration, onClose);

    // Add `role="alert"` to the toast container after rendering
    setTimeout(() => {
      // Use a more specific selector for the toast message container
      const toastElement = document.querySelector(
        '.ant-message-custom-content span'
      );

      if (toastElement) {
        toastElement.setAttribute('role', 'alert');
      }
    }, 0); // Ensures the DOM has been updated before modifying `role`
  };
};

export default ToastMaker;
